import { observer } from "mobx-react-lite";
import { Fragment, useState } from "react";
import {
  Col,
  Divider,
  Form,
  Modal,
  Row,
  Tabs,
  Image,
  ConfigProvider,
  Table,
  Button,
  Typography,
  Input,
  Space,
  Select,
} from "antd";
import { CommonStore, SignatureManageStore } from "../../../store";
import "./index.css";
import dictionary from "../../../utils/dictionary";
import {
  FilePdfFilled,
  EyeOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

function RowDetail() {
  const form = Form.useFormInstance();
  const { Column } = Table;

  return (
    <Fragment>
      <Modal
        width={"640px"}
        centered
        title={"签名信息"}
        open={SignatureManageStore.isOpenDetail}
        destroyOnClose={true}
        onCancel={() => SignatureManageStore.closeDetailModal()}
        footer={null}
        loading={SignatureManageStore.modalLoading}
      >
        <Form
          form={form}
          labelWrap
          labelCol={{ span: 8 }}
          style={{ marginTop: "20px" }}
          initialValues={SignatureManageStore.detailData}
        >
          <Row
            justify="start"
            style={{ maxHeight: "calc(75vh)", overflow: "auto" }}
          >
            <Col span={23}>
              <Form.Item label="模版签名">
                {SignatureManageStore.detailData.templateSignature}
              </Form.Item>
            </Col>
            <Col span={23}>
              <Form.Item label="统一社会信用代码证书">
                {SignatureManageStore.socialCreditCertificateObjectNamesUrl
                  ? SignatureManageStore.socialCreditCertificateObjectNamesUrl.map(
                      (item: any) => {
                        return <Image height={200} src={item.url} style={{paddingRight:'30px'}} />;
                      }
                    )
                  : ""}
              </Form.Item>
            </Col>
            <Col span={23}>
              <Form.Item label="隐私号订购凭证">
                {SignatureManageStore.orderVoucherObjectNamesUrl
                  ? SignatureManageStore.orderVoucherObjectNamesUrl.map(
                      (item: any) => {
                        return <Image height={200} src={item.url} style={{paddingRight:'30px'}}/>;
                      }
                    )
                  : ""}
              </Form.Item>
            </Col>
            <Col span={23}>
              <Form.Item label="签名授权凭证">
                {SignatureManageStore.signAuthzCertificateObjectNamesUrl
                  ? SignatureManageStore.signAuthzCertificateObjectNamesUrl.map(
                      (item: any) => {
                        return <Image height={200} src={item.url} style={{paddingRight:'30px'}} />;
                      }
                    )
                  : ""}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Fragment>
  );
}

export default observer(RowDetail);
